import script from "./walletConnectScanner.vue?vue&type=script&setup=true&lang=js"
export * from "./walletConnectScanner.vue?vue&type=script&setup=true&lang=js"

import "./walletConnectScanner.vue?vue&type=style&index=0&id=304ad48e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-304ad48e"]])

export default __exports__